module.exports = __webpack_public_path__ + "img/service-image_03.37cb93fc.jpg";